import { REQUEST, CANCELABLE_REQUEST } from '@/constants';
import moment from 'moment-timezone';

export const SHARED_CALENDARS_FETCH = 'SHARED_CALENDARS_FETCH';
export const SHARED_CALENDARS_SET = 'SHARED_CALENDARS_SET';
export const SHARED_CALENDARS_MINE_FETCH = 'SHARED_CALENDARS_MINE_FETCH';
export const SHARED_CALENDARS_MINE_SET = 'SHARED_CALENDARS_MINE_SET';
export const SHARED_CALENDARS_INVITE = 'SHARED_CALENDARS_INVITE';
export const SHARED_CALENDARS_GENERATE_LINK = 'SHARED_CALENDARS_GENERATE_LINK';
export const SHARED_CALENDARS_ACCEPT = 'SHARED_CALENDARS_ACCEPT';
export const SHARED_CALENDARS_REMOVE = 'SHARED_CALENDARS_REMOVE';
export const SHARED_CALENDAR_EVENTS_FETCH = 'SHARED_CALENDAR_EVENTS_FETCH';
export const SHARED_CALENDAR_EVENTS_SET = 'SHARED_CALENDAR_EVENTS_SET';

const localizeDateTimes =
    (timezone) =>
    ({ start_time, end_time }) => {
        timezone = timezone || moment.tz.guess();
        return {
            date: moment.utc(start_time).tz(timezone).startOf('day'),
            startTime: moment.utc(start_time).tz(timezone),
            endTime: moment.utc(end_time).tz(timezone),
        };
    };

export default {
    state: {
        sharedWithMe: [],
        sharedByMe: [],
        events: {},
    },
    mutations: {
        [SHARED_CALENDARS_SET](state, shares) {
            state.sharedWithMe = shares;
        },
        [SHARED_CALENDARS_MINE_SET](state, shares) {
            state.sharedByMe = shares;
        },
        [SHARED_CALENDAR_EVENTS_SET](state, { shareId, events }) {
            state.events = { ...state.events, [shareId]: events };
        },
    },
    actions: {
        async [SHARED_CALENDARS_FETCH]({ commit, dispatch }) {
            const res = await dispatch(REQUEST, { url: 'shared-calendars' });
            if (res && res.status === 200) {
                commit(SHARED_CALENDARS_SET, res.data.data);
            }
        },
        async [SHARED_CALENDARS_MINE_FETCH]({ commit, dispatch }) {
            const res = await dispatch(REQUEST, { url: 'shared-calendars/mine' });
            if (res && res.status === 200) {
                commit(SHARED_CALENDARS_MINE_SET, res.data.data);
            }
        },
        async [SHARED_CALENDARS_INVITE]({ dispatch }, { email }) {
            return await dispatch(REQUEST, {
                method: 'post',
                url: 'shared-calendars/invite',
                data: { email },
            });
        },
        async [SHARED_CALENDARS_GENERATE_LINK]({ dispatch }) {
            return await dispatch(REQUEST, {
                method: 'post',
                url: 'shared-calendars/link',
            });
        },
        async [SHARED_CALENDARS_ACCEPT]({ dispatch }, { token }) {
            return await dispatch(REQUEST, {
                method: 'post',
                url: `shared-calendars/accept/${token}`,
            });
        },
        async [SHARED_CALENDARS_REMOVE]({ dispatch }, { id }) {
            return await dispatch(REQUEST, {
                method: 'delete',
                url: `shared-calendars/${id}`,
            });
        },
        async [SHARED_CALENDAR_EVENTS_FETCH]({ commit, dispatch, rootState }, { shareId, params }) {
            const res = await dispatch(CANCELABLE_REQUEST, {
                url: `shared-calendars/${shareId}/events`,
                params,
            });
            if (res && res.status === 200) {
                const events = (res.data.data || []).map((event) => ({
                    ...event,
                    ...localizeDateTimes(rootState.profile?.user?.timezone)(event),
                    type: 'shared',
                    source: 'shared_calendar',
                    read_only: true,
                    sharedCalendarId: shareId,
                }));
                commit(SHARED_CALENDAR_EVENTS_SET, { shareId, events });
            }
        },
    },
    getters: {
        allSharedEvents(state) {
            return Object.values(state.events).flat();
        },
    },
};
